module.exports = __webpack_public_path__ + "static/media/product_sample_10.5cca338c.jpg";